import { useCallback, useEffect, useRef } from 'react';

interface Props {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  name: string;
  min: string;
  max: string;
  step: string;
}

function CustomRangeSlider({ id, label, value, onChange, name, min, max, step }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const tooltipRef = useRef<HTMLSpanElement>(null);

  const handleTooltip = useCallback(
    (val: string) => {
      if (!inputRef.current || !tooltipRef.current) return;
      const newVal = Number(((+val - +min) * 100) / (+max - +min));

      tooltipRef.current.innerHTML = val;
      tooltipRef.current.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    },
    [max, min],
  );

  useEffect(() => {
    handleTooltip(value);
  }, [handleTooltip, value]);

  return (
    <div className="input-container input-container--range">
      <label className="input-label" htmlFor={id}>
        {label}
      </label>
      <input
        ref={inputRef}
        type="range"
        className="range-field"
        autoComplete="off"
        id={id}
        name={name}
        value={value}
        onChange={(e) => {
          onChange(e);
        }}
        min={min}
        max={max}
        step={step}
      />
      <span className="input-tooltip" ref={tooltipRef} />
    </div>
  );
}

export default CustomRangeSlider;
